import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Header from './components/header';
import ProductInfo from './components/product-info';
import BookingInfo from './components/booking-info';
import CommissionInfo from './components/commission-info';
import StudentInfo from './components/student-info';

const tabList = ['PRODUCT_INFO', 'BOOKING_INFO', 'COMMISSION_INFO', 'STUDENT_INFO'];

export default function ReconciliationDetail({ booking, bookingJourney }) {
  const { t } = useTranslation();
  const history = useHistory();

  const [activeTab, setActiveTab] = useState(tabList[0]);

  const handleSelectTab = tab => {
    setActiveTab(tab);
    var element = document.querySelector(`#${tab?.toLowerCase()}`);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="reconciliation-details">
      <Header orderInfo={booking} t={t} history={history} bookingJourney={bookingJourney} />

      <div className={classnames('tab-wrapper')}>
        <For of={tabList} each="item" index="index">
          <a
            onClick={() => handleSelectTab(item)}
            className={classnames('tab-link', { 'active-link': activeTab === item })}
          >
            {t(`landlord.booking.reconciliation.details.${item?.toLowerCase()}.tab`)}
          </a>
        </For>
      </div>
      <div className="info-wrapper">
        <div id="product_info">
          <ProductInfo t={t} productInfo={booking?.order} id="product_info" />
        </div>

        <div id="booking_info">
          <BookingInfo t={t} bookingInfo={booking?.order} bookingJourney={bookingJourney} />
        </div>

        <div id="commission_info">
          <CommissionInfo
            id="commission_info"
            t={t}
            commissionInfo={{
              invoiceNumber: booking?.invoiceNumber,
              commissionTriggerPoint: booking?.order?.commissionTriggerPoint,
              ...booking?.commission,
            }}
          />
        </div>

        <div id="student_info">
          <StudentInfo t={t} studentInfo={booking?.order?.student} id="student_info" />
        </div>
      </div>
    </div>
  );
}
